import { ApplicationClient } from '~domain/api-clients/application-client';
import { yousetApiUrlRegistry } from '~domain/configs/url-registry/url-registry';
import { loadServerClient } from '~frontend-common/client/client-loader';

// Load application client for web admin
export const applicationClient: ApplicationClient = loadServerClient(
  ApplicationClient,
  yousetApiUrlRegistry.urls.application,
);
